import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { DecimalPipe } from '@angular/common';

export interface SalesPaymentParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface SalesPayment { 

    paymentDoneFrom: string;
    paymentType:string;
    paymentReferenceNo:number;
    phBillId:number;
    cash:number;
    creditCard:number;
    debitCard:number;
    upiPayment:number;
    cheque:number;
    dd:number;
    insuranceAmount:number;
    cardNo:number;
    cardType:string;
    transactionNo:string;
    chequeNo:string;
    chequeDate:any;
    chequeBank:string;
    chequeBranch:string;
    ddNo:string;
    ddDate:any;
    ddBank:string;
    ddBranch:string;
    upiReferenceNo: string;
    upiPaymentID: number;  
    payerReference:string;
    payerId:string;
    regId:string;
    admId: number;
    customerId: number;  
    tenantId:string;
    branchId:string;
    createdBy:any;
    createdDate:any;
    parameters?: SalesPaymentParameter[];
    links?: any;
}


export abstract class SalesPaymentData {
    abstract getall(url: string): Observable<SalesPayment[]>;
    abstract getById(url: string): Observable<any>;
    abstract create(url: string, data: SalesPayment[]): Observable<SalesPayment[]>;
    abstract update(url: string, data: SalesPayment): Observable<SalesPayment>;
    abstract list(url: string): Observable<any>; 
    abstract delete(url: string): Observable<SalesPayment[]>;
    
}
